import { createApp } from 'vue';
import { createI18n } from 'vue-i18n/dist/vue-i18n.cjs';
import App from './App.vue';

/* i18n */
const i18n = createI18n({
    locale: window.Store.app.lang,
    fallbackLocale: 'fr',
    messages: window.Store.components.bloglisting.translations
});

/* Creates app */
const create = () => {
    const el = document.querySelector('#blog-listing');
    const app = createApp(App, {
        categoriesFilters: (el.dataset.categories) ? JSON.parse(el.dataset.categories) : null,
        mrcFilters: (el.dataset.mrc) ? JSON.parse(el.dataset.mrc) : null,
        archiveUrl: (el.dataset.archiveUrl) ? el.dataset.archiveUrl : null,
    });
    
    app.use(i18n);
    app.mount(el);

    /* Store vue instance in Store */
    window.Store.components.bloglisting.vue.obj = app;
}

/* Store rendering function */
window.Store.components.bloglisting.vue.render = create;